var React = require('react');

function IconTemplate (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},[React.createElement("rect",{"width":"90.433","height":"21.923","rx":"5.481","key":0}),React.createElement("rect",{"x":"49.327","y":"30.144","width":"41.106","height":"24.663","rx":"5.481","key":1}),React.createElement("rect",{"y":"30.144","width":"41.106","height":"60.288","rx":"5.481","key":2}),React.createElement("rect",{"x":"49.327","y":"63.029","width":"41.106","height":"27.404","rx":"5.481","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"d":"M0 0h90v90H0z"})))]);
}

IconTemplate.defaultProps = {"viewBox":"0 0 90 90","fill":"currentColor"};

module.exports = IconTemplate;

IconTemplate.default = IconTemplate;
